export interface ProjectEntry {
  /** Card heading. */
  name: string;
  /** One or two sentences. Keep it factual. */
  description: string;
  /** Free-form label, for example `Prototype`, `Experiment`, `In progress`, `Shelved`. */
  status: string;
  /** Tools or languages used. Rendered as small tags. */
  tech: string[];
  /** Absolute path to an image in `public/`, for example `/playground/foo.png`. */
  image?: string;
  /** Fallback shown when `image` is absent. One or two characters, or an emoji. */
  icon?: string;
  /** Optional destination. External URLs open in a new tab. */
  url?: string;
}

export const projects: ProjectEntry[] = [];
